// `useHasPermissions` is the `@moment/app-config-ui` factory bound to web-ui's
// RTK `useGetSelfQuery`, keeping the package free of the app store while call
// sites keep importing the hook from `@/hooks/use-has-permissions`.
import { createUseHasPermissions } from '@moment/app-config-ui/permissions'

import { useGetSelfQuery } from '@/legacy-api/user-slice'

export type { PermissionMode } from '@moment/app-config-ui/permissions'

/** Current user's permission grants + fetch status, for the factory to read. */
function useSelfPermissions() {
  return useGetSelfQuery()
}

const useHasPermissions = createUseHasPermissions(useSelfPermissions)

// biome-ignore lint/style/noDefaultExport: Existing default export — call sites import this hook as the default
export default useHasPermissions
